module.exports = require("fast-memoize");